import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'

import App from './App.tsx'
import AdminMain from './components/admin/AdminMain.tsx'
import AdminPage from './components/admin/AdminPage.tsx'
import CoursesPage from './components/admin/CoursesPage.tsx'
import CourseTagsPage from './components/admin/courseTags/CourseTagsPage.tsx'
import ErrorTestPage from './components/admin/ErrorTestPage.tsx'
import StatsPage from './components/admin/StatsPage.tsx'
import UpdaterPage from './components/admin/UpdaterPage.tsx'
import UserFeedbackPage from './components/admin/UserFeedbackPage.tsx'
import LoginAsPage from './components/LoginAsPage.tsx'
import RootMain from './components/RootMain'

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RootMain />}>
          <Route index element={<App />} />
        </Route>
        <Route path="/admin" element={<AdminMain />}>
          <Route index element={<AdminPage />} />
          <Route path="courses" element={<CoursesPage />} />
          <Route path="course-tags" element={<CourseTagsPage />} />
          <Route path="login-as" element={<LoginAsPage />} />
          <Route path="stats" element={<StatsPage />} />
          <Route path="feedback" element={<UserFeedbackPage />} />
          <Route path="updater" element={<UpdaterPage />} />
          <Route path="backend-locales" element={<Navigate to="/admin" replace />} />
          <Route path="error-test" element={<ErrorTestPage />} />
        </Route>
      </Routes>
    </Router>
  )
}

export default AppRouter
